/**
 * The file enables `@/store/index.js` to import all vuex modules
 * in a one-shot manner. There should not be any reason to edit this file.
 */

import account from './modules/account'
import user from './modules/user'
import client from './modules/client'
import page from './modules/page'
import db from './modules/db'
import individualCenter from './modules/individualCenter'
import configuration from './modules/configuration'
import login from './modules/login'
import app from './modules/app'
import contactPerson from './modules/contactPerson'
import home from './modules/home'

const files = require.context('./modules', false, /\.js$/)
const modules = {}

files.keys().forEach(key => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

export default {
  namespaced: true,
  modules: {
    account,
    user,
    client,
    page,
    db,
    individualCenter,
    configuration,
    login,
    app,
    contactPerson,
    home
  }
}

